import { AutodeskActionTypes } from './types';
import { action } from 'typesafe-actions';

export const getAutodeskAccessTokenStart = (enquiryId?: number) =>
  action(AutodeskActionTypes.GET_AUTODESK_ACCESS_TOKEN_START, { enquiryId });
export const getAutodeskAccessTokenSuccess = (payload: any) =>
  action(AutodeskActionTypes.GET_AUTODESK_ACCESS_TOKEN_SUCCESS, payload);
export const getAutodeskAccessTokenFailure = (payload: string) =>
  action(AutodeskActionTypes.GET_AUTODESK_ACCESS_TOKEN_FAILURE, payload);

export const getAutodeskFileStart = (fileId: string, enquiryId?: number) =>
  action(AutodeskActionTypes.GET_AUTODESK_FILE_START, { fileId, enquiryId });
export const getAutodeskFileSuccess = (payload: any) =>
  action(AutodeskActionTypes.GET_AUTODESK_FILE_SUCCESS, payload);
export const getAutodeskFileFailure = (payload: string) =>
  action(AutodeskActionTypes.GET_AUTODESK_FILE_FAILURE, payload);

export const addSameAutodeskFileLoaded = () =>
  action(AutodeskActionTypes.ADD_SAME_AUTODESK_FILE_LOADED);

export const resetAutodesk = () => action(AutodeskActionTypes.RESET_AUTODESK);
